export const smallMobileMaxWidth = 440;
export const mobilePortraitMaxWidth = 567;
export const mobileLandscapeMaxWidth = 767;
export const tabletPortraitMaxWidth = 1023;
export const tabletLandscapeMaxWidth = 1365;
